import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useMemo } from "react";
import { useDocTransmittalContext } from "../DocTransmittal.context";
import AddIcon from "@mui/icons-material/Add";

export default function DocTransmittalDataForm({ values, dataGrid, formName }) {
  const {
    newDoc,
    setNewDoc,
    handleOpenDocTransmittalRegister,
    allDocTransmittals,
  } = useDocTransmittalContext();

  const transmittalNumberOptions = useMemo(() => {
    const seen = new Set();
    return (allDocTransmittals || [])
      .map((t) => String(t?.number ?? "").trim())
      .filter((num) => {
        if (!num || seen.has(num)) return false;
        seen.add(num);
        return true;
      })
      .sort((a, b) => a.localeCompare(b));
  }, [allDocTransmittals]);

  const onChange = (e) => {
    const { name, value } = e.target;
    if (formName) {
      setNewDoc({
        ...newDoc,
        [formName]: { ...newDoc[formName], [name]: value },
      });
      return;
    }

    const patch = { [name]: value };
    if (name === "number") {
      const transmittal = (allDocTransmittals || []).find(
        (t) => String(t?.number ?? "").trim() === String(value).trim(),
      );
      if (transmittal?.id) {
        patch.id = transmittal.id;
      }
      if (transmittal?.rev != null && transmittal.rev !== "") {
        patch.rev = transmittal.rev;
      }
    }

    setNewDoc({ ...newDoc, ...patch });
  };

  return (
    <Grid container spacing={2} columns={{ xs: 6.8 }}>
      {dataGrid.map((item, index) => (
        <React.Fragment key={index}>
          <Grid item xs={item.grid}>
            <Typography>{item.label}:</Typography>
          </Grid>
          <Grid item xs={["number", "purpose"].includes(item.field) ? 2.8 : 2}>
            {item.options ? (
              ["number"].includes(item.field) ? (
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Select
                    value={values[item.field]}
                    onChange={onChange}
                    name={item.field}
                    fullWidth
                    sx={{
                      "& .MuiSelect-select": {
                        p: 0.5,
                      },
                    }}
                  >
                    {transmittalNumberOptions.map((transmittalNumber) => (
                      <MenuItem value={transmittalNumber} key={transmittalNumber}>
                        {transmittalNumber}
                      </MenuItem>
                    ))}
                  </Select>

                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleOpenDocTransmittalRegister}
                  >
                    Add
                  </Button>
                </Box>
              ) : (
                <Select
                  value={values[item.field]}
                  onChange={onChange}
                  fullWidth
                  name={item.field}
                  sx={{
                    "& .MuiSelect-select": {
                      p: 0.5,
                    },
                  }}
                >
                  {item?.options.map((opt) => {
                    return (
                      <MenuItem value={opt} key={opt}>
                        {opt}
                      </MenuItem>
                    );
                  })}
                </Select>
              )
            ) : (
              <TextField
                variant="outlined"
                value={values[item.field]}
                name={item.field}
                onChange={onChange}
                hiddenLabel
                size="small"
                disabled={[
                  "Project Name",
                  "Project Type",
                  "Project Rev",
                ].includes(item.label)}
                fullWidth={["rev"].includes(item.field) ? false : true}
                inputProps={{ sx: { padding: "2px", pl: "5px" } }}
              />
            )}
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
}
